import script from "./AppCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./AppCheckbox.vue?vue&type=style&index=0&id=9b376b76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b376b76"]])

export default __exports__